import styled from "styled-components";
import UiAcordeon from "../../../../../components/Acordeon";

export const Acordeon = styled(UiAcordeon)``;
